import { render, staticRenderFns } from "./CrudUser.vue?vue&type=template&id=0faa04f0&scoped=true&"
import script from "./CrudUser.vue?vue&type=script&lang=js&"
export * from "./CrudUser.vue?vue&type=script&lang=js&"
import style0 from "./CrudUser.vue?vue&type=style&index=0&id=0faa04f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa04f0",
  null
  
)

export default component.exports